import Cookies from 'universal-cookie';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../utils/auth';

export const Home = () => {

    if (!isAuthenticated()) {
        return (<Navigate to="/login" />)
    }

    const cookies = new Cookies();
    let username = cookies.get('username');
    let speakersUrl = "https://prodigy.lb.ava.me/?session=" + username
    let transcriptsUrl = "https://transcribe.lb.ava.me/?session=" + username

    return (<>

    <div className="bg-white dark:bg-gray-800 ">
    <div className="text-center w-full mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 z-20">
        <h2 className="text-3xl font-extrabold text-black dark:text-white sm:text-4xl">
            <span className="block">
                Ava Labeling Tool
            </span>
            <span className="block text-indigo-500">
                What do you want to annotate?
            </span>
        </h2>
        <div className="lg:mt-0 lg:flex-shrink-0">
            <div className="mt-12 inline-flex space-x-10 rounded-md">
                        <a type="button" className="py-4 px-6  bg-indigo-600 hover:bg-indigo-700 focus:ring-indigo-500 focus:ring-offset-indigo-200 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg " href={ speakersUrl }>
                    Speakers
                </a>
                        <a type="button" className="py-4 px-6  bg-indigo-600 hover:bg-indigo-700 focus:ring-indigo-500 focus:ring-offset-indigo-200 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg " href={transcriptsUrl }>
                    Transcripts
                </a>
            </div>
        </div>
            </div>
        </div>

    </>)
};
